export default "__VITE_ASSET__9qtT3FnS__"